import { Message, Skeleton } from "@arco-design/web-react";
import moment from "moment";

export async function getBase64(file) {

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
//convert file url to base64
export async function urlToBase64(fileUrl) {
  try {
    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error('Failed to fetch the file.');
    }

    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    throw error;
  }
}
export const emailValidation = (text) => {
  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\.?[a-zA-Z]*$/;
  return emailRegex.test(text);
};
// setcookies
export const createCookieInHour = (cookieName, cookieValue, hourToExpire) => {
  let date = new Date();
  date.setTime(date.getTime() + (hourToExpire * 60 * 1000));
  document.cookie = cookieName + " = " + cookieValue + "; expires = " + date.toGMTString();
}
export const splitCamelCase = (data) => {
  let outdata = data.replace(/([a-z])([A-Z])/g, "$1 $2");
  let str = firstCamelCase(outdata);
  return str;
};
export const firstCamelCase = (data) => {

  let modifiedString = data.replace(/([A-Z])/g, ' $1');
  modifiedString = modifiedString.charAt(0).toUpperCase() + modifiedString.slice(1);
  return modifiedString
  // data.charAt(0).toUpperCase() + data.slice(1);
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
export const preventSpecialChars = (value, max = 10, regx = /[^a-zA-Z0-9 ]/g) => value?.replace(regx, '').slice(0, max).replace(" ", "").trim()

export const formatingValue = (value, max = 10, regx = /[^a-zA-Z0-9\s]/g) => {
  const result =  value?.replace(regx, '').slice(0, max).trimStart()
return result 
}

export const UsernameformatingValue = (value, max = 10, regx = /^[a-zA-Z0-9_\\s]*$/g) => {
  // Step 1: Remove invalid characters (anything that is not a letter or space)
  // const cleanedValue = value?.replace(regx, '');
  const cleanedValue = value;
  // Step 2: Ensure the cleaned value does not exceed the maximum length
  return cleanedValue?.slice(0, max);
};

export const limitCharacters = (value, max = 15) => value?.slice(0, max).trim();


export function filterRouteData(data, namesToFilter) {
  const result = {};
  for (const subMenu in data) {

    if (data?.hasOwnProperty(subMenu)) {

      const filteredItems = data[subMenu].filter(item => namesToFilter?.includes(item.name));
      result[subMenu] = filteredItems.slice(0, filteredItems.length);
    }

  }

  return result;

}
export const dataTableInitialLoader = (columns) => {
  let initialLoader = []
  let obj = {}
  for (let i = 0; i < 5; i++) {
    for (const j of columns) {
      obj[j.dataIndex] = <Skeleton style={{ height: '20px' }} text={{ rows: 1 }} />
    }
    initialLoader.push(obj)
  }
  return initialLoader
}

// get  local storage
export function getLocalStorage(key) {
  return localStorage.getItem(key);
}
// set loacstorage
export function setLocalStorage(data) {
  for (const key of Object.keys(data)) {
    localStorage.setItem(key, data[key]);
  }
}
export function findSelectedObjectElementIsEmpty(data, selectedElm) {

  let a = []
  let d = Object.keys(data).filter((itm) => selectedElm.includes(itm))


  for (let i of d) {
    a.push(data[selectedElm.find((itm) => itm == i)] == "")

    //  //console.log(a)
  }
  //  //console.log(a.filter((itm)=>itm))
  return a.filter((itm) => itm).length > 0 && a.filter((itm) => itm).every((itm) => itm == true)


}

// createNewArrayWithSelectedElements
export function createNewArrayWithSelectedElements(inputArray, selectedProperties) {
  return inputArray.map(item => {
    const selectedObject = {};
    selectedProperties.forEach(property => {
      if (item.hasOwnProperty(property)) {
        selectedObject[property] = item[property];
      }
    });
    return selectedObject;
  });
}

export const userValidation = (data, validatingData) => {
  
  // //console.log("validating  Data ", data)
  let validation = [];
  let blank_validation = validatingData;
  // let blank_validation = ['referral_code', 'dob', 'new_photo', 'first_name', 'email', 'remaining_coin', 'username', 'gender', 'new_adhar_image1', 'new_adhar_image2',]

  for (var i = 0; i < blank_validation.length; i++) {
    if (BlankValidation(blank_validation[i], data[blank_validation[i]])) {
      // //console.log("Validation passed for ", blank_validation[i]);
    } else {
      validation.push(blank_validation[i]);
    }
  }

  return validation;
};
const BlankValidation = (name, item) => {
  
  // alert('1')
  // //console.log("blank validate", name, item);
  if (item === "" || item === null || item.length < 1) {
    // ShowFailedMessage(name.replaceAll('_', ' ') + ' cannot be empty')
    //   showMessage(name + " cannot blank! ", "warning", "Blank Validation Failed", "top", "top-right", 5000)
    return 0;
  } else {
    //   showMessage(name + " validation passed! ", "success", "Validation Success", "bottom", "bottom-left", 2000)
    return true;
  }
};

export function combineAllRoutes(routeList) {
  let combinedRoutes = [];

  for (const key in routeList) {
    if (routeList?.hasOwnProperty(key)) {
      combinedRoutes = combinedRoutes.concat(routeList[key]);
    }
  }
  return combinedRoutes;
}

export async function suportFile(type, acceptType) {
  if (acceptType.includes("."+type.toLowerCase())) {
    return true;
  } else {
    // alert("file not supported");
    return false;
    // Proceed further
  }
}
export const objIterate = (data, not_valid) => {
  //console.log({ data });
  let IterateData = [];
  for (let key in data) {
    // //console.log(n, data[n]);
    // //""
    !not_valid?.includes(key) &&
      IterateData.push({ key: splitCamelCase(key).replaceAll("_", " "), value: !data[key] ? (data[key] === false? "false" : 'N/A') : data[key] });
  }

  return IterateData;
};


export const formateString = (str) => str.replace(/([a-z])([A-Z])/g, "$1 $2")


export const PreventNonNumeric = (e) => {
  if (e?.key.toLowerCase() === "e" || e?.key === "+" || e?.key === "-" || e?.key === "." || e?.key === "*" || e?.key === "=" || e?.key === "_" || e?.key === '.') {
    e?.preventDefault()
  }
}

// check is empty
export function areAllValuesNotEmpty(obj) {
  return Object.values(obj).every(value => {
    return value !== null && value !== undefined && value !== '';
  });
}


export const convertUtcToBrowserTimeZone = (utcDateTimeString) => {
  const format = typeof utcDateTimeString == "object"
  if (format) {
    return
  }
  
  // var utc = new Date()
  // const utcDate = new Date(utcDateTimeString ); // Append 'Z' to indicate UTC

  // // Use toLocaleString with options to handle time zone conversion
  // const localString = utcDate.toLocaleString(undefined, { timeZone: 'UTC' });
  // const localString = new Date(utcDateTimeString).toISOString()
  var local = new Date(utcDateTimeString);
  var offset = local.getTimezoneOffset();
  var utc = new Date(local.getTime() - offset * 60000)
  var localString = moment(utc).format("YYYY-MM-DD hh:mma")
  // const utcDate = new Date(utcDateTimeString);
  // const localString = utcDate.toLocaleString();

  // const localString = moment.utc(utcDateTimeString, "YYYY-MM-DDTHH:MM:SS").format('YYYY-MM-DD hh:mma');

  // if (localString == "Invalid date") {
  //   ""
  // }

  return localString;
};

export const convertDateTime = (dateString) => {
 const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1; // getUTCMonth() returns 0-11, so add 1
  const day = date.getUTCDate();
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';

  // adjust hours for 12-hour format
  const adjustedHours = hours % 12;
  const hoursString = adjustedHours === 0 ? '12' : adjustedHours.toString();

  // format the date string
  const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ${hoursString}:${minutes.toString().padStart(2, '0')}${ampm}`;

  return formattedDate;
}


export const formatDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 -> 12
  const formattedHours = String(hours).padStart(2, "0");

  return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
};


export const handleCopy=(data)=>{
  navigator.clipboard.writeText(data);
  Message.success("copy to clipboard")
}

// Chatbot
export const mimeTypesMap = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
  'application/pdf': 'PDF',
  'image/jpeg': 'JPEG Image',
  'image/png': 'PNG Image',
};
export const getFileTypeLabel = (mimeType) => {
  return mimeTypesMap[mimeType] || 'Unknown File Type';
};
export const chatbotsettings = {
  enableVersion: true,
  enableLanguageforVoice: true,
  enableVoiceRecording: true,
  enableAttachments: true,
  enableHistory:false
};

export const clearLocalStorage = () => {
  try {
    return localStorage.clear();
  } catch (err) {
    return err;
  }
};

export const resetNavigation = (path) => window.location.replace(path);

export const fileToPreviewUrl = (file) => {
  const blob = new Blob([file], { type: file?.type });
  return URL.createObjectURL(blob);
};